export const linkButtonTestId = 'cta-link-button';
export const uploaderButtonTestId = 'cta-uploader-button';
export const imageUploaderTestId = 'image-uploader-wrapper';
